import { useMutation } from "@tanstack/react-query";
import type { PostAuthSignUpPasswordlessFetchResponse } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { signUpPasswordlessAsync } from "State/Auth/SignUp/SignUpPasswordlessState";
import { useDispatch } from "react-redux";
import { v4 as uuid } from "uuid";

type Props = {
  onSignUpSuccess?: () => void;
  onError?: () => void;
  transactionPublicID?: string;
  campaignCode?: string;
  affiliateCode?: string;
};

// Mutate-time variables take precedence over the hook-level props — used by flows
// where the transactionPublicID is only known after a previous request (PayPoint scan).
type Variables = {
  transactionPublicID?: string;
};

export const useSignUpPasswordless = ({
  onSignUpSuccess,
  onError,
  transactionPublicID,
  campaignCode,
  affiliateCode,
}: Props = {}) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (variables?: Variables) =>
        new Promise<PostAuthSignUpPasswordlessFetchResponse>(
          (resolve, reject) => {
            dispatch(
              signUpPasswordlessAsync.request({
                model: {
                  isAnonymous: true,
                  login: uuid(),
                  transactionPublicID:
                    variables?.transactionPublicID ?? transactionPublicID,
                  campaignCode,
                  affiliateCode,
                },
                successCallback: resolve,
                failedCallback: reject,
              }),
            );
          },
        ),
    ),
    onSuccess: onSignUpSuccess,
    onError,
  });
};
